var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"consumer-profile-view"},[(_vm.isConsumerProfileFetching || _vm.isEmailNotificationsSettingsFetching)?_c('loading'):_c('consumer-profile')],1)}
var staticRenderFns = []

export { render, staticRenderFns }